// extracted by mini-css-extract-plugin
export default {"wrapper":"NewOrderWizard_wrapper_CueAG","field":"NewOrderWizard_field_ViOIE","actions":"NewOrderWizard_actions_HMttT","folder-path":"NewOrderWizard_folder-path_a3Dqf"};